<div *ngIf="this.tenant == 'pl'">
<div class="d-flex justify-content-between">
  <div class="card-sub-heading my-3">Payment Plan</div>
  <button mat-icon-button (click)="this.dialogRef.close()" type="button">
    <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
  </button>
</div>

<div class="my-4" *ngFor="let item of props?.sale_order_rx_detail">
  <div class="d-flex">
    <div class="grey bold">RX ID:</div>
    <div class="bold ml-2">{{ item.RxNum }}</div>
  </div>
  <div class="d-flex justify-content-between border-bottom py-3 grey">
    <div>RX Plan</div>
    <div>Plans Pays</div>
  </div>

  <div
    class="d-flex justify-content-between border-bottom py-3"
    *ngFor="let val of item?.kroll_rx_pln"
  >
    <div>{{ val.SubPlanCode }}</div>
    <ng-container *ngIf="tenant == 'pl'; else wylo">
      <div>{{ getPaysVal(val.Pays) }}</div>
    </ng-container>
    <ng-template #wylo>
      <div>{{ getPaysVal((+val.Pays + (item.additional_cost != null ? +item.additional_cost : 0)).toString())}}</div>
    </ng-template>
  </div>
</div>
</div>

<div *ngIf="this.tenant == 'sl' || this.tenant == 'qc' || this.tenant == 'wylo' || this.tenant == 'ml' || this.tenant == 'ml_qc'">
<div class="d-flex justify-content-between">
  <div class="card-sub-heading my-3 Order_Summary_title">Order Summary</div>
  <button mat-icon-button (click)="this.dialogRef.close()" type="button">
    <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
  </button>
</div>

<div class="my-4 border">
  <div class="p-3" *ngIf="props?.item?.orderSummery">
    <div class="d-flex justify-content-between">
      <div>
        <h3> Subtotal </h3>
      </div>
      <div>{{ props?.item?.orderSummery?.subTotal | number: ".1-2" }}</div>
    </div>
    <div class="d-flex justify-content-between">
      <div>
        <h3>Insured Amount</h3>
      </div>
      <div>{{ props?.item?.orderSummery?.insuredAmount | number: ".1-2" }}</div>
    </div>
    <div class="d-flex justify-content-between" *ngIf="props?.item?.orderSummery?.addCoverageAmount !== undefined">
      <div style="position: relative;width: 75%;">
        <h3>Additional Coverage</h3>
        <p *ngIf="props?.item?.rxNumMsg !== undefined && props?.item?.rxNumMsg !== ''" style="font-size: 13px;color: rgb(243, 115, 115);margin-top: -17px;width: 80%;line-height: normal;">
          ( {{props.item.rxNumMsg}} )
        </p>
      </div>
      <div >{{ props?.item?.orderSummery?.addCoverageAmount }}</div>
    </div>


    <div class="d-flex justify-content-between">
      <div>
        <h3>Copay Amount</h3>
      </div>
      <div>{{ props?.item?.orderSummery?.copayAmount | number: ".1-2"}}</div>
    </div>
    <div class="d-flex justify-content-between" >
        <div>
          <h3>Promo Code</h3>
        </div>
        <div>{{ props?.item?.promoCode?.code ? props?.item?.promoCode?.code : '-' }}</div>
      </div>
    <div class="d-flex justify-content-between">
      <div>
        <h3>Promotion</h3>
      </div>
      <div>{{ props?.item?.orderSummery?.discountAmount | number: ".1-2" }}</div>
    </div>
    <div *ngIf="this.props?.item?.orderSummery?.cqp_discount > 0" class="d-flex justify-content-between">
      <div>
        <h3>Discount</h3>
      </div>
      <div>{{ this.props?.item?.orderSummery?.cqp_discount || 0 | number: ".1-2" }}</div>
    </div>
    <div class="d-flex justify-content-between">
      <div>
        <h3>Delivery Fee</h3>
      </div>
      <div>{{ props?.item?.orderSummery?.deliveryFee | number: ".1-2"}}</div>
    </div>
    <div class="d-flex justify-content-between border-bottom">
      <div>
        <h3>Tax</h3>
      </div>
      <div>{{ props?.item?.orderSummery?.tax | number: ".1-2"}}</div>
    </div>
    <div class="d-flex justify-content-between mt-3">
      <div>
        <h2>Total</h2>
      </div>
      <div>{{ props?.item?.orderSummery?.total | number: ".1-4"  }}</div>
    </div>
  </div>
</div>
</div>

